import { useState } from "react";
import { hasMainLineRow } from "../components/DrawingSettingsModal/drawingSettingsRows";
import { isValidLevelValue } from "../engine/drawings/drawingStyles";

/**
 * Edits of the settings modal of a drawing, the chart changes on Save. A level
 * value is kept as text while it is typed; what cannot be a level on Save stays as it was.
 * Without the Main Line row nothing in the modal hides the whole drawing, so a Save shows it.
 *
 * @param {object} drawing - engine.getDrawings() item
 * @returns {{ draft: object, changeDraft: Function, changeLevel: Function, getSettings: Function }}
 *   getSettings: `{ style, isVisible }` of engine.updateDrawing
 */
const useDrawingDraft = (drawing) => {
  const { style: savedStyle } = drawing;
  const [draft, setDraft] = useState({
    ...savedStyle,
    isVisible: hasMainLineRow(drawing.type) ? drawing.isVisible : true,
    ...(savedStyle.levels && {
      levels: savedStyle.levels.map((level) => ({ ...level, value: String(level.value) })),
    }),
  });

  const changeDraft = (change) => setDraft((current) => ({ ...current, ...change }));

  const changeLevel = (changedIndex, change) =>
    setDraft((current) => ({
      ...current,
      levels: current.levels.map((level, index) => (index === changedIndex ? { ...level, ...change } : level)),
    }));

  const getSettings = () => {
    const { isVisible, ...style } = draft;

    if (style.levels) {
      style.levels = style.levels.map((level, index) => {
        const value = Number(level.value);

        return { ...level, value: isValidLevelValue(value) ? value : savedStyle.levels[index].value };
      });
    }

    return { style, isVisible };
  };

  return { draft, changeDraft, changeLevel, getSettings };
};

export default useDrawingDraft;
